export type StatusTone = 'success' | 'warning' | 'error' | 'info' | 'neutral' | 'brand' | 'draft';

export const STATUS_TONES: readonly StatusTone[] = [
  'success',
  'warning',
  'error',
  'info',
  'neutral',
  'brand',
  'draft',
];

/** The dot color for a tone; the label beside it always carries the meaning. */
export const TONE_DOT: Record<StatusTone, string> = {
  success: 'bg-success-400',
  warning: 'bg-warning-400',
  error: 'bg-error-400',
  info: 'bg-blue-light-400',
  neutral: 'bg-gray-400 dark:bg-gray-500',
  brand: 'bg-brand-400',
  draft: 'bg-theme-purple-500',
};
